// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cookie-outer {
  z-index: 11;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: scroll;
  padding: 20%;
}
.cookie-outer h3 {
  border-left: 2px solid white;
  margin-top: 40px;
  padding-left: var(--motes-padding);
}
.cookie-outer .sections-list .active a {
  text-decoration: underline;
  text-decoration-color: var(--primary-color);
  text-underline-offset: 5px;
  line-height: 28px;
}
.cookie-outer::-webkit-scrollbar {
  display: none;
}

.close-cookies {
  display: flex;
  justify-content: flex-end;
  position: fixed;
  z-index: 12;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: var(--motes-padding) 30px;
  pointer-events: none;
  padding-top: 60px;
  background: linear-gradient(rgba(20, 20, 20, 0), rgba(20, 20, 20, 0.8), rgb(20, 20, 20));
}

.close-cookies button {
  pointer-events: initial;
}

/* a {
    color: var(--motes-gold);
}

h1, h2 {
    text-align: left;
}

h1::after, h2::after {
    content: none;
}
*/
/* 
.sections a {
    text-transform: lowercase;
}

.sections span.active a {
    color: white !important;
} */`, "",{"version":3,"sources":["webpack://./motes-sdk/src/cookie/cookie.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;AACJ;AACI;EACI,4BAAA;EACA,gBAAA;EACA,kCAAA;AACR;AAEI;EACI,0BAAA;EACA,2CAAA;EACA,0BAAA;EACA,iBAAA;AAAR;AAGI;EACI,aAAA;AADR;;AAKA;EACI,aAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,kCAAA;EACA,oBAAA;EACA,iBAAA;EACA,wFAAA;AAFJ;;AAKA;EACI,uBAAA;AAFJ;;AASA;;;;;;;;;;;CAAA;AAaA;;;;;;;GAAA","sourcesContent":[".cookie-outer {\n    z-index: 11;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    overflow-y: scroll;\n    padding: 20%;\n\n    h3 {\n        border-left: 2px solid white;\n        margin-top: 40px;\n        padding-left: var(--motes-padding);\n    }\n\n    .sections-list .active a {\n        text-decoration: underline;\n        text-decoration-color: var(--primary-color);\n        text-underline-offset: 5px;\n        line-height: 28px;\n    }\n\n    &::-webkit-scrollbar {\n        display: none;\n    }\n}\n\n.close-cookies {\n    display: flex;\n    justify-content: flex-end;\n    position: fixed;\n    z-index: 12;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    box-sizing: border-box;\n    padding: var(--motes-padding) 30px;\n    pointer-events: none;\n    padding-top: 60px;\n    background: linear-gradient(rgba(20,20,20,0), rgba(20,20,20,.8), rgba(20,20,20,1));\n}\n\n.close-cookies button {\n    pointer-events: initial;\n}\n\n// .scroll-container::-webkit-scrollbar {\n//     display: none;\n// }\n\n/* a {\n    color: var(--motes-gold);\n}\n\nh1, h2 {\n    text-align: left;\n}\n\nh1::after, h2::after {\n    content: none;\n}\n*/\n\n/* \n.sections a {\n    text-transform: lowercase;\n}\n\n.sections span.active a {\n    color: white !important;\n} */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
